<template>
  <div>
    <section class="content">
      <div class="container-fluid">
        <div class="row clearfix">
          <div class="bg-cyan" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
              <div class="col-md-4 searching">
                <span class="h_page">Analisis Hasil Monev Dapodik</span>
                <br>
                <br>
              </div>
              <div class="col-md-4"></div>
              <div class="col-md-4 searching">

                <div class="input-group">
                  <span class="input-group-btn">
                    <button @type="button" class="btn bg-orange btn-sm waves-effect" title="Tambah Data">
                      <i class="material-icons">add</i>
                    </button>
                  </span>
                  <input type="text" class="form-control" placeholder="Cari data" id="caridata">
                </div> <br>

              </div>
            </div>
          </div>

          <div class="col-xs-12 card">
            <!-- ============================================================ MULAI ======================================================================== -->

            <!-- ============================================================ MULAI ======================================================================== -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>



<script>
const ADD_URL = URL_APP + "api/v1/instrumen_guru/";
import uniqid from "uniqid";

export default {
  name: "monev_instrumen_guru",
  data: function() {
    return {
      ada: "ada"
    };
  },

  methods: {},
  // =============================================================== METHODS =========================================================================

  mounted() {}
};
</script>
